import { UserRole } from '@/types/user';

export const getUserInitials = (name?: string | null) => {
  const nameParts = name?.trim().split(/\s+/).filter(Boolean) ?? [];

  if (nameParts.length === 0) {
    return undefined;
  }

  const firstInitial = nameParts[0][0];
  const lastInitial =
    nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '';

  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const getRoleBadgeVariant = (role: string) => {
  switch (role) {
    case UserRole.COMPANY_ADMIN:
      return 'destructive';
    case UserRole.COMPANY_MANAGER:
      return 'default';
    default:
      return 'secondary';
  }
};
